const ErrorLogger = (
    error,
    groupMessage = "API Request Error",
    fetchingMessage = "Fetching data..."
) => {
    console.group(`%c${groupMessage}`, "color: blue; font-weight: bold;");
    if (fetchingMessage) {
        console.log(fetchingMessage);
    }
    console.error("%cError:", "color: red; font-weight: bold;", error?.message || "Unknown error");
    console.groupEnd();
};

export { ErrorLogger };
